'use client';

import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';

import { Button } from '../ui/button';

import { Input, InputProps } from './input';

export type PasswordInputProps = Omit<InputProps, 'type' | 'suffix'>;

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleButton = (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      onClick={togglePasswordVisibility}
      className="h-6 w-6 -mr-1 text-muted-foreground hover:text-accent-foreground"
      tabIndex={-1}
      aria-label={showPassword ? 'Hide password' : 'Show password'}
    >
      {showPassword ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
    </Button>
  );

  return (
    <Input {...props} ref={ref} type={showPassword ? 'text' : 'password'} suffix={toggleButton} />
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
